import { render, staticRenderFns } from "./BroadcastPage.vue?vue&type=template&id=7a4167a2&"
import script from "./BroadcastPage.vue?vue&type=script&lang=js&"
export * from "./BroadcastPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports